import { AHText, AHTextFonts, Box, useSpaceSize } from "arkh";
import React, { PropsWithChildren, ReactNode } from "react";

import { View } from "react-native";

export function ResultRow(
  props: PropsWithChildren<{
    title: string;
    stale?: boolean;
    subTitle?: React.ReactNode;
  }>
) {
  const { stale, children } = props;
  const title = props.title || props.subTitle;
  const subTitle =
    props.subTitle && props.subTitle !== title ? props.subTitle : undefined;
  return (
    <View
      style={{
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <ResultBlock stale={stale}>{children}</ResultBlock>
      <Box style={{ flex: 1 }}>
        <ResultTitle stale={stale}>{title}</ResultTitle>
        {subTitle ? <ResultSubTitle>{subTitle}</ResultSubTitle> : null}
      </Box>
    </View>
  );
}

const ResultTitle: React.FC<React.PropsWithChildren<{ stale?: boolean }>> = ({
  children,
  stale = false,
}) => {
  return (
    <AHText
      numberOfLines={1}
      ellipsizeMode="tail"
      adjustsFontSizeToFit
      type="subtitle"
      minimumFontScale={0.7}
      font={AHTextFonts.BOLD}
      color={stale ? "washedText" : "darkerText"}
      spaceLeft="small"
    >
      {children}
    </AHText>
  );
};
const ResultSubTitle = ({ children }: { children?: ReactNode | undefined }) => {
  return (
    <AHText
      numberOfLines={1}
      ellipsizeMode="tail"
      adjustsFontSizeToFit
      type="body"
      minimumFontScale={0.7}
      font={AHTextFonts.MEDIUM}
      spaceLeft="small"
    >
      {children}
    </AHText>
  );
};

const ResultBlock: React.FC<React.PropsWithChildren<{ stale?: boolean }>> = ({
  children,
  stale,
}) => {
  const width = useSpaceSize("xlarge");
  return (
    <View
      style={{
        width,
        alignItems: "center",
        flexDirection: "column",
        opacity: stale ? 0.7 : 1,
      }}
    >
      {children}
    </View>
  );
};
